'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = require('../../utils/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _ProgressSpinner = require('../ProgressSpinner');

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('content-loader--');

var ContentLoader = function ContentLoader(_ref) {
  var small = _ref.small;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('content-loader', modifiers({ small: small })) },
    _react2.default.createElement(_ProgressSpinner2.default, {
      thickness: 3,
      size: 36,
      blue: true
    })
  );
};

ContentLoader.propTypes = {
  small: _propTypes2.default.bool
};

exports.default = ContentLoader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ContentLoading/index.js
// module id = 151
// module chunks = 0